import * as React from 'react';

export const header = {
  heading: 'My Account Registration and Use'
};
export const richText1 = {
  id: 'MyAccountRegistration',
  html:
    '                <p>My Account registration is a service provided by our website. You do not have to register to browse our website. We may require that you register with a My Account to make online purchases. \n'
    + '                 When you register, you are asked for personal information such as your name, address, phone number, email address, \n'
    + '                 and a username and password that you select. You may also optionally provide information regarding your interests and home improvement projects or register your credit cards.\n'
    + '                 This information may be used to help make your online shopping quicker and easier, by pre-filling certain parts of your shopping information. </p> \n'
    + '              <p><br/></p> \n'
    + '              <p>Click  <a href="https://www.homedepot.com/c/PH_MyAccount">here</a> to read more about the terms and conditions that govern your registration and use of our My Account service.\n</p>'
};
